import OnlyLoader from "components/Loaders/OnlyLoader";
import Box from "konnekt/Box";
import Button from "konnekt/Buttons";
import Icon from "konnekt/Icon";
import Image from "konnekt/Image";
import Label from "konnekt/Label";
import { ResponsiveModal } from "konnekt/Modal";
import React, { useEffect, useState } from "react";

const gifDuration = 1750;
const completionDuration = 5000;

const SuccessPopUp = ({ isOpen, onHide }) => {
  const [showStaticImage, setShowStaticImage] = useState(false);
  const [isFiveSecondsCompleted, setIsFiveSecondsCompleted] = useState(false);

  useEffect(() => {
    let gifTimer;
    let completionTimer;

    if (isOpen) {
      gifTimer = setTimeout(() => {
        setShowStaticImage(true);
      }, gifDuration);

      completionTimer = setTimeout(() => {
        setIsFiveSecondsCompleted(true);
      }, completionDuration);
    }

    return () => {
      clearTimeout(gifTimer);
      clearTimeout(completionTimer);
    };
  }, [isOpen]);

  return (
    <ResponsiveModal isOpen={isOpen} onHide={onHide} maxWidth="480px">
      <Box
        cursor="pointer"
        className="z-index-5000"
        position="absolute"
        top="10px"
        right="10px"
        border="1px solid #464D6D"
        bg="#FEFEFE"
        borderRadius="50%"
        p="4px"
        onClick={onHide}
      >
        <Icon iconName="close" iconSize="2tiny" />
      </Box>
      <Box
        p="24px"
        display="flex"
        gridGap="12px"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Image
          source={
            showStaticImage
              ? ["/images/completed.png"]
              : ["/images/completed.gif"]
          }
          width="84px"
          height="84px"
        />
        <Label variant="text6">Number Connected Successfully</Label>
        {isFiveSecondsCompleted && (
          <Label variant="text7" textAlign="center">
            We will notify you once your business verification status has been
            updated
          </Label>
        )}
        <Box
          display="flex"
          width="80%"
          gridGap="8px"
          justifyContent="center"
          alignItems="center"
          bg="#F0F9FF"
          borderRadius="6px"
          p="12px 8px"
          mb="8px"
        >
          <OnlyLoader />
          <Label variant="text7">
            {isFiveSecondsCompleted
              ? "Seems like it is taking longer than expected"
              : " Business Verification is in progress"}
          </Label>
        </Box>
        {isFiveSecondsCompleted && (
          <Button
            height="40px"
            text="Notify Later"
            onClick={onHide}
            type="primaryV3"
            width="90%"
          />
        )}
      </Box>
    </ResponsiveModal>
  );
};

export default SuccessPopUp;
